import { Grid, List, Text, ListItem } from '@chakra-ui/react';
import { useTranslation } from '../../lib/hooks.context';
import { BenefitTeaser } from '../../types';
import Teaser from '../Teaser';

interface Props {
  benefits: BenefitTeaser[];
}

const PlainBenefitstList = ({ benefits }: Props) => {
  const t = useTranslation();

  return (
    <Grid
      templateColumns={[
        '1fr',
        'repeat(auto-fit, minmax(250px, 1fr))',
        'repeat(auto-fit, minmax(325px, 1fr))',
      ]}
      gap="10"
      mb="10"
      as={List}
    >
      {benefits.map(({ id, lead: wysiwyg, image, site, title }) => (
        <Teaser
          key={`${id || title}-${site}`}
          as={ListItem}
          {...{
            heading: {
              style: 'h4',
              importance: 'h3',
              title,
            },
            wysiwyg,
            image,
            site,
          }}
        />
      ))}
      {!benefits?.length ? <Text>{t('no_benefits')}</Text> : null}
    </Grid>
  );
};

export default PlainBenefitstList;
